const FORM_DEEP_CUSTOMER = 'deep-customer-empathy'
const FORM_DEVELOP_EMPATHY = 'develop-your-empathy'
const FORM_SKETCH = 'sketch'
const FORM_EMOTION =  'emotion'
const FORM_CUSTOMER_PROBLEM = 'customer-problem'
const FORM_IDEAL_STATE = "ideal-state"
const FORM_JS_BROAD_NARROW = 'broad-narrow'
const FORM_JS_BROAD_NARROW_BRAINSTORMING = 'broad-narrow-brainstorming'
const FORM_JS_BROAD_NARROW_GOING_EVEN = 'going-even-narrow'
const FORM_JS_RAPID_EXPERIMENTS = 'rapid-experiments'
const FORM_JS_RAPID_EXPERIMENTS_INFORMATION = 'rapid-experiments-informational'
const FORM_JS_RAPID_EXPERIMENTS_PLANNING_INFORMATIONAL = 'Planning Informational Interviews'
const FORM_JS_RAPID_EXPERIMENTS_READY = 'rapid-experiments-Ready'
const FORM_JS_RAPID_JOB_SHADOW = 'job-shadow'
const FORM_JS_RAPID_JOB_SHADOW_EXPERIENCE = 'researching-job-shadow-experience'
const FORM_JS_RAPID_JOB_SHADOW_PREPARING = 'preparing-job-shadow-experience'


const FORM_BRAINSTORMING = 'brainstorming'
const FORM_TOP_IDEAS = 'topideas'
const FORM_CAREER = 'career'
const FORM_INTERVIEW_RESULTS = "answers"
const FORM_EXPERIENCE_RESULTS = "experience"

function getStepFromForm(formName) {
    switch (formName) {
        case FORM_DEEP_CUSTOMER:
            return 2
        case FORM_DEVELOP_EMPATHY:
            return 3
        case FORM_SKETCH:
            return 4
        case FORM_EMOTION:
            return 5
        case FORM_CUSTOMER_PROBLEM:
            return 6
        case FORM_IDEAL_STATE:
            return 7
        case FORM_JS_BROAD_NARROW:
            return 8
        case FORM_JS_BROAD_NARROW_BRAINSTORMING:
            return 9
        case FORM_BRAINSTORMING:
            return 10
        case FORM_JS_BROAD_NARROW_GOING_EVEN:
            return 11
        case FORM_TOP_IDEAS:
            return 12
        case FORM_CAREER:
            return 13
        case FORM_JS_RAPID_EXPERIMENTS:
            return 14
        case FORM_JS_RAPID_EXPERIMENTS_INFORMATION:
            return 15
        case FORM_JS_RAPID_EXPERIMENTS_PLANNING_INFORMATIONAL:
            return 16
        case FORM_JS_RAPID_EXPERIMENTS_READY:
            return 17
        case FORM_INTERVIEW_RESULTS:
            return 18
        case FORM_JS_RAPID_JOB_SHADOW:
            return 19
        case FORM_JS_RAPID_JOB_SHADOW_EXPERIENCE:
            return 20
        case FORM_JS_RAPID_JOB_SHADOW_PREPARING:
            return 21
        case FORM_EXPERIENCE_RESULTS:
            return 22
    }
    return 0
}

function getStepForDisplay(step) {
    return (step === 19 || step === 0) ? step + 1 : step
}

export default {
    FORM_DEEP_CUSTOMER,
    FORM_DEVELOP_EMPATHY,
    FORM_SKETCH,
    FORM_EMOTION,
    FORM_CUSTOMER_PROBLEM,
    FORM_IDEAL_STATE,
    FORM_JS_BROAD_NARROW,
    FORM_JS_BROAD_NARROW_BRAINSTORMING,
    FORM_JS_BROAD_NARROW_GOING_EVEN,
    FORM_BRAINSTORMING,
    FORM_JS_RAPID_EXPERIMENTS,
    FORM_JS_RAPID_EXPERIMENTS_INFORMATION,
    FORM_JS_RAPID_EXPERIMENTS_PLANNING_INFORMATIONAL,
    FORM_JS_RAPID_EXPERIMENTS_READY,
    FORM_TOP_IDEAS,
    FORM_CAREER,
    FORM_INTERVIEW_RESULTS,
    FORM_EXPERIENCE_RESULTS,
    FORM_JS_RAPID_JOB_SHADOW,
    FORM_JS_RAPID_JOB_SHADOW_EXPERIENCE,
    FORM_JS_RAPID_JOB_SHADOW_PREPARING,
    getStepFromForm,
    getStepForDisplay
}
